import React, { ComponentProps, forwardRef, useState } from "react";
import * as Form from "@radix-ui/react-form";

type FloatingLabelProps = {
  hasError: boolean;
  isSelectInput?: boolean;
  focusUncontrolled?: boolean;
};

// eslint-disable-next-line react/display-name
const FloatingLabelInput = forwardRef<
  any,
  FloatingLabelProps & ComponentProps<"input">
>(
  (
    {
      hasError,
      value,
      isSelectInput,
      onBlur,
      onFocus,
      focusUncontrolled,
      ...rest
    },
    ref
  ) => {
    const [isFocused, setIsFocused] = useState(false);

    return (
      <>
        <style>
          {" "}
          {`
          #${rest.name} {
            background-color: ${
              hasError ? "var(--clay-200)" : "transparent"
            } !important;
          }
        `}
        </style>
        <Form.Control
          className={`peer floating h-10 w-full border-b-[1px] border-forest-900 placeholder-transparent py-2 pl-0 pr-6 text-xl z-10 border-t-0 border-x-0
            outline-none ${isFocused && "border-forest-900 border-b-[2.5px]"}
            ${
              focusUncontrolled &&
              "focus:border-forest-900 focus:border-b-[2.5px]"
            }
            md:text-lg not-italic font-normal leading-[145%] md:leading-[150%] -tracking-[0.4px] md:-tracking-[.18px] rounded-none appearance-none
            ${hasError ? "bg-clay-200" : "bg-transparent"}
            ${isSelectInput ? "cursor-pointer" : "cursor-text"}
            ${value !== "Select one" ? "text-forest-900" : "text-forest-500"}`}
          placeholder={rest.name}
          ref={ref}
          onFocus={e => {
            onFocus && onFocus(e);
            setIsFocused(true);
          }}
          onBlur={e => {
            setTimeout(() => setIsFocused(false), 180);
            onBlur && onBlur(e);
          }}
          value={value}
          id={rest.name}
          {...rest}
        />
      </>
    );
  }
);

export default FloatingLabelInput;
